/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'lib/services/auth-service';
import { Style } from 'lib/Style';
import { UiStorage } from 'lib/services/ui-storage';
import { AovCalculationService } from 'lib/services/aov-calculation-service';
import { AovComparisonProductResult } from 'lib/services/aov-comparison-product-result';
import { UI_STATE } from 'lib/services/ui-state';
import { AovVerzekerde } from 'lib/validation/aov-verzekerde';
import { NgxSpinnerService } from 'ngx-spinner';
import { OccupationItem } from './occuptationItem';

@Component({
    selector: 'app-verzekerde',
    standalone: false,
    templateUrl: './verzekerde.component.html',
    styleUrl: './verzekerde.component.css',
})
export class VerzekerdeComponent implements OnInit {
    @Input() model: AovVerzekerde;

    public occupationItems: OccupationItem[] = [];
    public top3: AovComparisonProductResult[] = [];
    public allProducts: AovComparisonProductResult[] = [];

    public ui: any;

    constructor(
        private _router: Router,
        private _auth: AuthService,
        private _storage: UiStorage,
        private _calculator: AovCalculationService,
        private _spinner: NgxSpinnerService,
        @Inject(UI_STATE) ui: any
    ) {
        this.model = _storage.load() || {};
        this.ui = ui;
    }

    ngOnInit() {
        this.occupationItems = occupationList || [];
        if (this.model.hoursPerWeekAdministrativeWork === undefined) this.model.hoursPerWeekAdministrativeWork = 0;
        if (this.model.hoursPerWeekManagement === undefined) this.model.hoursPerWeekManagement = 0;
        if (this.model.hoursPerWeekCommercial === undefined) this.model.hoursPerWeekCommercial = 0;
        if (this.model.hoursPerWeekManualLabour === undefined) this.model.hoursPerWeekManualLabour = 0;
        if (this.model.kilometersPerYearTravel === undefined) this.model.kilometersPerYearTravel = 0;

        if (Style.value) {
            this.model.style = Style.value.toLowerCase();
            if (this.model.style === "zzp") {
                this.model.indexationOfBenefit = true;
                this.model.benefitIndexationMethod = 'CBS';
                this.model.indexationOfInsuredAmount = false;
            }
        }

        this._auth.registerTokenFromGlobal();

        // RvL: this seems a bit of a hack. It does however seem to fix bug 165482....
        // The modelvalue is set ok initially, but the selectize seems to clear it (after it has rendered the dropdown fine)
        var savedOccupation = this.model.occupation;
        setTimeout(() => {
            this.model.occupation = savedOccupation;
        }, 0);
    }

    showSpinner(
        timeoutInMilliSeconds: number = 1000*3600 // 1 hour default timeout
    ) {
        this._spinner.show();
        setTimeout(() => {
            this.hideSpinner();
        }, timeoutInMilliSeconds);
    }

    hideSpinner() {
        this._spinner.hide();
    }

    private getPremiums(key: string) {
        try {
            this._calculator.getPremiums(key, result => {
                if (result.isComplete) {
                    console.log("complete");
                    this._storage.saveAfd(result.afd);
                    this.allProducts = result.productResults;
                    this.top3 = this.allProducts.slice(0);
                    this.top3 = this.top3.sort(function (a, b) { return (a.premium > b.premium) ? 1 : ((b.premium > a.premium) ? -1 : 0); })
                    if (this.top3.length > 3) {
                        this.top3 = this.top3.slice(0, 3);
                    }
                    this.hideSpinner();
                    setTimeout(function () {
                        const elem = document.getElementById('product-premiums');
                        if (elem) {
                            elem.scrollIntoView();
                        }
                    }, 500);
                } else {
                    console.log("waiting");
                    const that = this;
                    setTimeout(function () {
                        that.getPremiums(key);
                    }, 1000);
                }
            }, error => {
                console.log("premiums error:", error);
                this.hideSpinner();
            });
        } catch (ex) {
            console.log("premiums exception:", ex);
            this.hideSpinner();
        }
    }

    public DoBlurYearlyIncome() {
        // initially set the insured amount to 0.8 * yearlyIncome (but only when insured amount is empty)
        if (this.model.yearlyIncome) {
            this.model.insuredAmount = Math.floor(0.8 * this.model.yearlyIncome * 100) / 100;
        }
    }

    public onCalculate() {
        this._spinner.show();
        try {
            this._calculator.initPremiums(this.model, data => {
                this.getPremiums(data.initializeCalculationResult);
            }, error => {
                console.log("calculate error:", error);
                this.hideSpinner();
            });
        } catch (ex) {
            console.log("calculate exception:", ex);
            this.hideSpinner();
        }
    }

    public onNext() {
        this._storage.save(this.model);
        this._router.navigate(['/advies']);
    }

    indexationOfBenefitChanged(value: boolean) {
        if (value === false) {
            this.model.benefitIndexationMethod = undefined;
        }
    }

}
